import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import Cookies from 'universal-cookie';
import _get from 'lodash/get';
import ImgCDN from '../../../components/ImgCDN';

const VideoGalleryListItem = (props) => {
    const renderVideo = (videoObj, id) => {
        let videoComponent = '';
        const cookies = new Cookies();
        const comfortCookiesAccepted = cookies.get('comfortCookiesAccepted');
        const functionalCookiesAccepted = cookies.get(
            'functionalCookiesAccepted',
        );

        if (comfortCookiesAccepted) {
            videoComponent = [
                <ReactPlayer
                    url={videoObj.field_media_oembed_video
                        .replace(
                            'https://youtu.be/',
                            'https://www.youtube.com/watch?v=',
                        )
                        .replace(
                            'https://www.youtu.be/',
                            'https://www.youtube.com/watch?v=',
                        )}
                    controls
                    key={`player_${id}`}
                />,
            ];
        } else if (
            functionalCookiesAccepted &&
            (/https:\/\/(www\.)?youtube\.com\//.test(
                videoObj.field_media_oembed_video,
            ) ||
                /https:\/\/(www\.)?youtu\.be\//.test(
                    videoObj.field_media_oembed_video,
                ))
        ) {
            videoComponent = [
                <ReactPlayer
                    url={
                        videoObj &&
                        videoObj.field_media_oembed_video
                            .replace(
                                'https://www.youtube.com/watch?v=',
                                'https://www.youtube-nocookie.com/embed/',
                            )
                            .replace(
                                'https://youtu.be/',
                                'https://www.youtube-nocookie.com/embed/',
                            )
                            .replace(
                                'https://www.youtu.be/',
                                'https://www.youtube-nocookie.com/embed/',
                            )
                    }
                    config={{
                        youtube: {
                            embedOptions: {
                                host: 'https://www.youtube-nocookie.com',
                            },
                        },
                    }}
                    controls
                    key={`player_${id}`}
                />,
            ];
        } else {
            const image = _get(videoObj, 'relationships.thumbnail');

            videoComponent = [
                <a
                    href={videoObj.field_media_oembed_video}
                    target="_blank"
                    rel="noreferrer"
                    key={`thumbnail_${id}`}
                >
                    <ImgCDN
                        image={image}
                        fluid={true}
                        fluidPadding={false}
                        ratio={1.75}
                    />
                </a>,
            ];
        }

        return <>{videoComponent}</>;
    };

    const { item } = props;

    return (
        <div className="video-gallery-item" key={`player_wrap_${item.id}`}>
            {renderVideo(item, item.id)}
        </div>
    );
};

export default VideoGalleryListItem;

VideoGalleryListItem.propTypes = {
    item: PropTypes.objectOf(PropTypes.any).isRequired,
    listIndex: PropTypes.number,
};
